import { SubmissionError } from 'redux-form';
import { has } from 'lodash';

import { loading } from 'State/actions';

export async function validate(
  dispatch,
  MPWWebApi,
  resourceName,
  model,
  loadingType,
  resetScroll
) {
  await MPWWebApi.postGenericInsertUpdate(resourceName, model).catch(error => {
    if (loadingType) {
      dispatch(loading(loadingType, false));
    }

    if (resetScroll) {
      resetScroll();
    }

    if (has(error, 'response.data.Errors')) {
      throw new SubmissionError(
        error.response.data.Errors.reduce((acc, cur) => {
          acc[cur.Title] = cur.Message;
          return acc;
        }, {})
      );
    } else {
      throw new SubmissionError({
        _error: 'The information entered is invalid',
      });
    }
  });
}



// WEBPACK FOOTER //
// ./src/common/ReduxFormSubmitValidation.js